<template>
  <div 
    v-if="shouldShowNavigation"
    :class="`fixed left-0 right-0 flex justify-center z-10 ${isPreviewOpen ? 'top-24' : 'bottom-8'}`"
  >
    <div v-if="activeNavigation.length > 1" class="relative py-2 w-full px-4">
      <div class="bg-white shadow-md rounded-full border-[3px] border-white mx-auto flex justify-between items-center">
        
        <!-- QR Code button (for specific domains) -->
        <div
          v-if="activeNavigation.includes('qr_code') && isMasDomain"
          :class="`inline-flex items-center rounded-full py-2 px-5 max-sm:px-3 min-w-min w-1/2 justify-center cursor-pointer`"
          :style="{
            backgroundColor: currentDisplay === 'qr_code' ? tourSettings.contrast_color : '',
            color: currentDisplay === 'qr_code' ? tourSettings.contrast_text_color : ''
          }"
          @click="switchPointNavigation('qr_code')"
        >
          <QrCodeIcon class="h-5 w-5 my-1" />
          <span class="whitespace-nowrap ml-2 max-xs:hidden max-sm:text-xs">{{ $t('qr_code') }}</span>
        </div>

        <!-- Map button (for map, google_maps, or open_streetmap) -->
        <div
          v-if="activeNavigation.includes('map') || activeNavigation.includes('google_maps') || activeNavigation.includes('open_streetmap')"
          :class="`inline-flex items-center rounded-full py-2 px-5 max-sm:px-3 min-w-min w-1/2 justify-center cursor-pointer`"
          :style="{
            backgroundColor: isMapActive ? tourSettings.contrast_color : '',
            color: isMapActive ? tourSettings.contrast_text_color : ''
          }"
          @click="switchPointNavigation(getMapToggleName())"
        >
          <MapIcon class="h-5 w-5 my-1" />
          <span class="whitespace-nowrap ml-2 max-[280px]:hidden max-sm:text-xs">{{ $t('map') }}</span>
        </div>

        <!-- List button -->
        <div
          v-if="activeNavigation.includes('list')"
          :class="`inline-flex items-center rounded-full py-2 px-5 max-sm:px-3 min-w-min w-1/2 justify-center cursor-pointer`"
          :style="{
            backgroundColor: pointNavigation === 'list' ? tourSettings.contrast_color : '',
            color: pointNavigation === 'list' ? tourSettings.contrast_text_color : ''
          }"
          @click="switchPointNavigation('list')"
        >
          <ListBulletIcon class="h-5 w-5 my-1" />
          <span class="whitespace-nowrap ml-2 max-[280px]:hidden max-sm:text-xs">{{ $t('list') }}</span>
        </div>

        <!-- QR Code button (for non-MAS domains) -->
        <div
          v-if="activeNavigation.includes('qr_code') && !isMasDomain"
          :class="`inline-flex items-center rounded-full py-2 px-5 max-sm:px-3 min-w-min w-1/2 justify-center cursor-pointer`"
          :style="{
            backgroundColor: currentDisplay === 'qr_code' ? tourSettings.contrast_color : '',
            color: currentDisplay === 'qr_code' ? tourSettings.contrast_text_color : ''
          }"
          @click="switchPointNavigation('qr_code')"
        >
          <QrCodeIcon class="h-5 w-5 my-1" />
          <span class="whitespace-nowrap ml-2 max-xs:hidden max-sm:text-xs">{{ $t('qr_code') }}</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { QrCodeIcon, MapIcon, ListBulletIcon } from '@heroicons/vue/24/outline'

export default {
  name: 'PointNavigationBar',
  components: {
    QrCodeIcon,
    MapIcon,
    ListBulletIcon
  },
  props: {
    selectedView: {
      type: String,
      default: null
    },
    currentDisplay: {
      type: String,
      default: null
    },
    isPreviewOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('settings', ['tourSettings']),
    ...mapGetters('pointNavigation', ['pointNavigation', 'showPointNavigation']),
    
    // Get active navigation options from tour settings
    activeNavigation() {
      if (this.selectedView) return []
      const active = Object.keys(this.tourSettings?.navigation ?? {}).filter(key => 
        this.tourSettings?.navigation?.[key]?.active
      )
      console.log('NavigationBar - tourSettings:', this.tourSettings)
      console.log('NavigationBar - activeNavigation:', active)
      return active
    },
    
    // Check if navigation should be shown
    shouldShowNavigation() {
      const shouldShow = (this.activeNavigation.length > 1 || this.activeNavigation.includes('qr_code')) && this.showPointNavigation
      console.log('NavigationBar - shouldShowNavigation:', shouldShow, {
        activeNavigationLength: this.activeNavigation.length,
        hasQrCode: this.activeNavigation.includes('qr_code'),
        showPointNavigation: this.showPointNavigation
      })
      return shouldShow
    },
    
    // Check if current domain is MAS domain
    isMasDomain() {
      return window.location.hostname === "mas.tourio.com" || window.location.hostname === "mas.dev.tourio.com"
    },
    
    // Check if map navigation is active
    isMapActive() {
      return this.pointNavigation === 'outdoor_map' || this.pointNavigation === 'map'
    }
  },
  methods: {
    ...mapActions('pointNavigation', ['switchPointNavigation']),
    
    // Get the appropriate map toggle name based on available navigation options
    getMapToggleName() {
      if (this.tourSettings?.navigation?.google_maps?.active || this.tourSettings?.navigation?.open_streetmap?.active) {
        return 'outdoor_map'
      }
      if (this.tourSettings?.navigation?.map?.active) {
        return 'map'
      }
      if (this.tourSettings?.navigation?.list?.active) {
        return 'list'
      }
      if (this.tourSettings?.navigation?.qr_code?.active) {
        return 'qr_code'
      }
      return null
    }
  }
}
</script>

<style scoped>
/* Add any additional styles if needed */
</style> 